import React, { useEffect, useState } from "react";
import JobPostItem from "./components/JobPostItem";
import SelectInput from "./components/SelectInput";

const JobSearch = () => {
    const [jobPosts, setJobPosts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [departments, setDepartments] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([]);

    useEffect(() => {
        fetch(`${current_group.site_url}/wp-json/custom/v1/jobs`)
            .then((response) => response.json())
            .then((data) => setJobPosts(data))
            .catch((error) => console.error("Error fetching job posts:", error));
    }, []);

    useEffect(() => {
        fetch(`${current_group.site_url}/wp-json/wp/v2/department?per_page=100`)
            .then((res) => res.json())
            .then((data) => setDepartments(data))
            .catch((err) => console.error("Error fetching departments:", err));
    }, []);

    useEffect(() => {
        fetch(`${current_group.site_url}/wp-json/wp/v2/country?per_page=100`)
            .then((res) => res.json())
            .then((data) => setCountries(data))
            .catch((err) => console.error("Error fetching countries:", err));
    }, []);

    const filteredJobs = jobPosts.filter((post) => {
        const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase());

        const matchesDepartment =
            selectedDepartment.length === 0 ||
            (post.department && selectedDepartment.some((d) => post.department.includes(d)));

        const matchesCountry =
            selectedCountry.length === 0 ||
            (post.country && selectedCountry.some((c) => post.country.includes(c)));

        return matchesSearch && matchesDepartment && matchesCountry;
    });

    return (
        <div>
            <div className="careers__filters" role="region" aria-labelledby="filters-heading">
                <h5 id="filters-heading">CURRENT OPPORTUNITIES</h5>

                <input
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                <hr />

                <fieldset>
                    <legend className="sr-only" style={{ display: "none" }}>
                        Filter by country and department
                    </legend>

                    <SelectInput
                        name="country"
                        label="Countries"
                        options={countries.map((c) => ({ value: c.name, label: c.name }))}
                        value={selectedCountry}
                        onChange={(vals) => setSelectedCountry(vals)}
                        icon={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <g style={{ mixBlendMode: "difference" }} opacity="0.64">
                                    <path
                                        d="M1.3335 8.49967H14.6668M1.3335 8.49967C1.3335 12.1816 4.31826 15.1663 8.00016 15.1663M1.3335 8.49967C1.3335 4.81778 4.31826 1.83301 8.00016 1.83301M14.6668 8.49967C14.6668 12.1816 11.6821 15.1663 8.00016 15.1663M14.6668 8.49967C14.6668 4.81778 11.6821 1.83301 8.00016 1.83301M8.00016 1.83301C9.66768 3.65858 10.6153 6.0277 10.6668 8.49967C10.6153 10.9717 9.66768 13.3408 8.00016 15.1663M8.00016 1.83301C6.33264 3.65858 5.38499 6.0277 5.3335 8.49967C5.38499 10.9717 6.33264 13.3408 8.00016 15.1663"
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        }
                    />

                    <SelectInput
                        name="department"
                        label="Departments"
                        options={departments.map((d) => ({ value: d.name, label: d.name }))}
                        value={selectedDepartment}
                        onChange={(vals) => setSelectedDepartment(vals)}
                        icon={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <g style={{ mixBlendMode: "difference" }} opacity="0.64">
                                    <path
                                        d="M10.6668 5.16667C10.6668 4.54669 10.6668 4.2367 10.5987 3.98236C10.4137 3.29218 9.87465 2.75308 9.18447 2.56815C8.93013 2.5 8.62014 2.5 8.00016 2.5C7.38018 2.5 7.07019 2.5 6.81586 2.56815C6.12567 2.75308 5.58658 3.29218 5.40164 3.98236C5.3335 4.2367 5.3335 4.54669 5.3335 5.16667M3.46683 14.5H12.5335C13.2802 14.5 13.6536 14.5 13.9388 14.3547C14.1897 14.2268 14.3937 14.0229 14.5215 13.772C14.6668 13.4868 14.6668 13.1134 14.6668 12.3667V7.3C14.6668 6.55326 14.6668 6.1799 14.5215 5.89468C14.3937 5.6438 14.1897 5.43982 13.9388 5.31199C13.6536 5.16667 13.2802 5.16667 12.5335 5.16667L3.46683 5.16667C2.72009 5.16667 2.34672 5.16667 2.06151 5.31199C1.81063 5.43982 1.60665 5.6438 1.47882 5.89468C1.3335 6.1799 1.3335 6.55326 1.3335 7.3L1.3335 12.3667C1.3335 13.1134 1.3335 13.4868 1.47882 13.772C1.60665 14.0229 1.81063 14.2268 2.06151 14.3547C2.34672 14.5 2.72009 14.5 3.46683 14.5Z"
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        }
                    />
                </fieldset>
            </div>

            <ul className="careers__list" role="list" aria-label="Job results">
                {filteredJobs.length > 0 ? (
                    filteredJobs.map((post) => <JobPostItem key={post.id} post={post} />)
                ) : (
                    <li className="p">No job postings match your filters.</li>
                )}
            </ul>
        </div>
    );
};

export default JobSearch;
